import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the top on every route change.
// Skips when navigating to an in-page anchor (hash present).
export default function ScrollToTop({ smooth = true }) {
  const location = useLocation();
  const { pathname, hash } = location;

  useEffect(() => {
    // Do not interfere with anchor/hash navigation
    if (hash) return;

    const supportsSmooth = 'scrollBehavior' in document.documentElement.style;
    if (smooth && supportsSmooth) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, smooth]);

  return null;
}